$mol_icon_align_vertical_bottom $mol_icon path \M22 22H2V20H22V22M10 2H7V18H10V2M17 8H14V18H17V8Z
